import { useRef, useState } from "react";
import { saveUtilityStateOperation } from "../utilityApi";

export default function useSopEditSave({ onSuccess, onRefresh, notify }) {
  const [saving, setSaving] = useState(false);
  const [canRefresh, setCanRefresh] = useState(false);
  const inFlight = useRef(false);
  const save = async (payload) => {
    const commodityId = Number(payload.CommodityId);
    if (inFlight.current || payload.Id == null || (commodityId !== 1 && commodityId !== 2)) return;
    inFlight.current = true;
    setSaving(true);
    try {
      const result = await saveUtilityStateOperation({
        EnerexUtilityStateId: payload.EnerexUtilityStateId,
        Id: payload.Id,
        EnerexUtilityId: payload.EnerexUtilityId,
        EnerexStateId: payload.EnerexStateId,
        CommodityId: commodityId,
        ServiceReferenceNumberRequired: Boolean(payload.ServiceReferenceNumberRequired),
        ServiceReferenceNumberDescription: payload.ServiceReferenceNumberDescription || null,
        KeyNameRequired: Boolean(payload.KeyNameRequired),
        KeyNameDescription: payload.KeyNameDescription ?? "",
        EnrollmentLeadTime: payload.EnrollmentLeadTime ?? "",
        EnerexResidentialUOM: payload.enerexResidentialUOM ?? null,
        EnerexCommercialUOM: payload.enerexCommercialUOM ?? null,
        EnerexLargeCommercialUOM: payload.enerexLargeCommercialUOM ?? null,
        ...(payload.CommodityIds?.length && { CommodityIds: [...payload.CommodityIds] }),
        ...(payload.ExpectedMappingIds?.length && { ExpectedMappingIds: [...payload.ExpectedMappingIds] }),
        ...(payload.StateIds && { StateIds: [...payload.StateIds] }),
        ...(payload.CommodityMappings && { CommodityMappings: payload.CommodityMappings.map((mapping) => ({ ...mapping })) }),
        ...(payload.UserName && { UserName: payload.UserName }),
      });
      const success = result?.isSuccess ?? result?.IsSuccess;
      if (success !== true && (!Array.isArray(result) || !result.length)) {
        throw new Error(result?.message || result?.Message || "State mappings were not saved.");
      }
      setCanRefresh(false);
      await onSuccess(result?.message || result?.Message || "State of operations updated successfully");
    } catch (error) {
      setCanRefresh(error.status === 409);
      notify(error.message || "Failed to update state mappings", "error");
    } finally {
      inFlight.current = false;
      setSaving(false);
    }
  };
  const refresh = async () => {
    if (inFlight.current || !canRefresh) return;
    inFlight.current = true;
    setSaving(true);
    try {
      await onRefresh();
      setCanRefresh(false);
    } catch (error) {
      notify(error.message || "Failed to reload state mappings", "error");
    } finally {
      inFlight.current = false;
      setSaving(false);
    }
  };
  return { saving, canRefresh, save, refresh, reset: () => setCanRefresh(false) };
}
